// generated by genversion
const version = '6.13.1';

export { version };
//# sourceMappingURL=version.mjs.map
